<div class="content rasContent">
  <h2 class="title">{{ isEditing ? Texts.editTitle : Texts.title }}</h2>
  <mat-icon class="close-modal" (click)="closeModal()">close</mat-icon>
  <form [formGroup]="fraudeForm" class="selectRasForms">
    <div class="row">
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de persona*</mat-label>
          <mat-select
            (ngModelChange)="changeCi()"
            formControlName="tipo_de_persona"
            placeholder="Natural"
          >
            <mat-option *ngFor="let person of typeOfPerson" [value]="person">
              {{ person }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Número de Identificación *</mat-label>
          <input
            matInput
            formControlName="numero_de_identificacion"
            (keyup)="changeCi()"
            type="text"
          />
        </mat-form-field>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Apellido *</mat-label>
          <input matInput formControlName="apellido" type="text" />
        </mat-form-field>
      </div>

      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Nombre *</mat-label>
          <input matInput formControlName="nombre" type="text" />
        </mat-form-field>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Oficina *</mat-label>
          <mat-select formControlName="oficina" placeholder="Oficina ">
            <mat-option
              *ngFor="let oficina of oficinasExample"
              [matTooltip]="oficina"
              [value]="oficina"
            >
              {{ oficina }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Región *</mat-label>
          <mat-select formControlName="region" placeholder="Región ">
            <mat-option
              *ngFor="let region of regionesExample"
              [matTooltip]="region"
              [value]="region"
            >
              {{ region }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Teléfono de contacto*</mat-label>
          <input
            matInput
            placeholder="(0212) 462-35-32."
            formControlName="telefono"
            type="text"
          />
        </mat-form-field>
      </div>
      <div class="col-4 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Correo*</mat-label>
          <input
            matInput
            placeholder="ejemplo@ejemplo.com"
            formControlName="correo"
            type="text"
          />
        </mat-form-field>
        <mat-error *ngIf="fraudeForm.get('correo').hasError('email')"
          >El correo es <strong>invalido</strong></mat-error
        >
      </div>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Celular*</mat-label>
          <input
            matInput
            placeholder="(0412) 462-35-32."
            formControlName="celular"
            type="text"
          />
        </mat-form-field>
      </div>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Cliente*</mat-label>
          <input matInput formControlName="cliente" type="text" />
        </mat-form-field>
      </div>
      <div class="col-12 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Domicilio*</mat-label>
          <textarea matInput formControlName="domicilio"></textarea>
        </mat-form-field>
      </div>

      <h2 class="col-12"><b>Datos del caso</b></h2>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Canal*</mat-label>
          <mat-select formControlName="canal">
            <mat-option *ngFor="let canal of canalesExample" [value]="canal">
              {{ canal }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Datos del instrumento financiero*</mat-label>
          <mat-select formControlName="instrumento">
            <mat-option
              *ngFor="let instrumento of instrumentosExample"
              [value]="instrumento"
            >
              {{ instrumento }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- <case-files
      [(files)]="files"
      [(newFiles)]="newFiles"
      [(deleteFiles)]="deleteFiles"
      [isEditing]="isEditing"
    ></case-files> -->
  </form>
  <div class="button">
    <button
      mat-raised-button
      class="primary-btn rounded buttonRas"
      [disabled]="!fraudeForm.valid || isLoading"
      (click)="save()"
    >
      {{ isEditing ? Texts.edit : Texts.create }}
    </button>
  </div>
</div>
